import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconZip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconZip"><Path d="M9.75 3.75001H14.25M9.75 7.75001H14.25M17.25 3.75C18.9069 3.75 20.25 5.09315 20.25 6.75L20.25 17.25C20.25 18.9069 18.9069 20.25 17.25 20.25H6.75001C5.09315 20.25 3.75 18.9069 3.75001 17.25L3.75 6.75001C3.74999 5.09315 5.09314 3.75 6.75 3.75M9.75 11.75H14.25V14C14.25 15.2426 13.2426 16.25 12 16.25C10.7574 16.25 9.75 15.2426 9.75 14V11.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconZip;
